import { render, staticRenderFns } from "./introduceList.vue?vue&type=template&id=28e7b031&scoped=true"
import script from "./introduceList.vue?vue&type=script&lang=js"
export * from "./introduceList.vue?vue&type=script&lang=js"
import style0 from "./introduceList.vue?vue&type=style&index=0&id=28e7b031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7b031",
  null
  
)

export default component.exports